import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  convertTitle: 'Convert and send a payment in a single step!',
  convertSubtitle:
    'When sending a payment, you can also check the real-time exchange rate without needing to use the conversion tool.',
  convertHide: 'Do not show again',
  convertNavConversions: 'Convert',
  convertNavSavings: 'Savings calculator',
  convertConvertionTableTitle: 'Conversions',
  convertProfileMenu: 'Profile',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const CONVERT_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    convertTitle: '¡Convierte y envía un pago en un solo flujo!',
    convertSubtitle:
      'Al enviar un pago también puedes revisar la tasa de cambio en tiempo real sin necesidad de usar la herramienta convertir.',
    convertHide: 'No volver a mostrar',
    convertNavConversions: 'Conversiones',
    convertNavSavings: 'Calculadora de ahorros',
    convertConvertionTableTitle: 'Conversiones',
    convertProfileMenu: 'Perfil',
  },
};

export default CONVERT_LANGUAGE_LABELS;
